import React from 'react';
import { NavLink } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import InventoryIcon from '@mui/icons-material/Inventory'; // Added for Product Management
import CategoryIcon from '@mui/icons-material/Category'; // Added for Category Management
import StorefrontIcon from '@mui/icons-material/Storefront'; // Added for Brand Management
import BuildIcon from '@mui/icons-material/Build'; // Added for Services Content
import ContactMailIcon from '@mui/icons-material/ContactMail'; // Added for Contact Page
import MenuIcon from '@mui/icons-material/Menu'; // Added for Navigation Bar
import BrandingWatermarkIcon from '@mui/icons-material/BrandingWatermark'; // Added for Dealership Logos
import LockResetIcon from '@mui/icons-material/LockReset'; // For Update Password
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'; // For Manage Users
import { Box, Typography } from '@mui/material';

const Sidebar = () => {
  const menuItems = [
    { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
    { text: 'Hero Section', icon: <HomeIcon />, path: '/dashboard/hero-section' },
    { text: 'About Us Section', icon: <InfoIcon />, path: '/dashboard/about-us' },
    { text: 'Services Content', icon: <BuildIcon />, path: '/dashboard/services-content' },
    { text: 'Contact Us Content', icon: <ContactMailIcon />, path: '/dashboard/contact-us' }, // New Link
    { text: 'Product Management', icon: <InventoryIcon />, path: '/dashboard/products' },
    { text: 'Header Settings', icon: <MenuIcon />, path: '/dashboard/header-settings' },
    { text: 'Dealership Logos', icon: <BrandingWatermarkIcon />, path: '/dashboard/dealership-logos' },
    { text: 'Update Password', icon: <LockResetIcon />, path: '/dashboard/update-password' },
    { text: 'Manage Users', icon: <ManageAccountsIcon />, path: '/dashboard/manage-users' },
  ];

  return (
    <div className="sidebar">
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', mb: 2 }}>
          Admin Panel
        </Typography>
      </Box>
      
      <List>
        {menuItems.map((item) => (
          <ListItem 
            button 
            component={NavLink} 
            to={item.path} 
            key={item.text}
            sx={{
              color: 'white',
              '&.active': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                borderLeft: '4px solid #1976d2',
              },
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
              },
              pl: 3,
            }}
          >
            <ListItemIcon sx={{ color: 'white', minWidth: '40px' }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.text} className="sidebar-text" />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default Sidebar;
